import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react';
import { DtoProjectType } from '@/shared/constants';

interface ProjectMetadata {
  projectId: number | null;
  storyId: number | null;
}

interface ProjectTypeContextType {
  projectType: DtoProjectType | null;
  setProjectType: (projectType: DtoProjectType) => void;
  projectMetadata: ProjectMetadata;
  setProjectMetadata: (metadata: ProjectMetadata) => void;
}

const defaultProjectTypeContext: ProjectTypeContextType = {
  projectType: null,
  setProjectType: () => {},
  projectMetadata: { projectId: null, storyId: null },
  setProjectMetadata: () => {},
};

const ProjectTypeContext = createContext<ProjectTypeContextType>(
  defaultProjectTypeContext,
);

interface ProjectTypeProviderProps {
  children: ReactNode;
}

export const ProjectTypeProvider = ({ children }: ProjectTypeProviderProps) => {
  const [projectType, setProjectType] =
    useState<ProjectTypeContextType['projectType']>(null);
  const [projectMetadata, setProjectMetadata] = useState<ProjectMetadata>({
    projectId: null,
    storyId: null,
  });

  const value = useMemo(
    () => ({
      projectType,
      setProjectType,
      projectMetadata,
      setProjectMetadata,
    }),
    [projectType, projectMetadata],
  );

  return (
    <ProjectTypeContext.Provider value={value}>
      {children}
    </ProjectTypeContext.Provider>
  );
};

export const useProjectTypeContext = () => {
  return useContext(ProjectTypeContext);
};

/**
 * LTS(Long-to-Short) 프로젝트인지 확인합니다.
 * spotlight(1)이 LTS 프로젝트 타입입니다.
 */
export const useIsLtsProject = () => {
  const { projectType } = useProjectTypeContext();
  return projectType === DtoProjectType.spotlight;
};
